import { PDFUrl } from '@/hooks/useFileDowload';
import { Axios, AxiosService, ExternalAxios } from '@/services/Axios';
import { Sentry } from '@/services/Sentry';
import { AssignSalesRepresentativeVm } from '@/types';

import { ChangeStagePayload } from './types';

export class OpportunityControllerClass {
  private interactiveApiModule: GlobalAny = undefined;

  constructor(private APIService: AxiosService) {}

  changeStage = (id: string, payload: ChangeStagePayload) => {
    return this.APIService.patch(`/opportunities/${id}`, payload);
  };

  fetchOpportunities = () => {
    return this.APIService.get('/opportunities');
  };

  fetchOpportunity = (id: string) => {
    return this.APIService.get(`/opportunities/${id}`);
  };

  updatePhotoAlbumLink = (id: string, photoAlbumLink: string) => {
    return this.APIService.patch(`/opportunities/${id}`, { photoAlbumLink });
  };

  assignSalesRepresentative = (payload: AssignSalesRepresentativeVm) => {
    return this.APIService.post('/opportunities/assign-sales-representative', payload);
  };

  generatePDF = async (contactId: string, proposalId: string): Promise<Blob | null> => {
    const pdfGeneratorFunctionLink = `api/v1/proposals/${proposalId}/pdf`;

    const payload = {
      contactId,
    };

    try {
      const response = await this.APIService.post<PDFUrl>(pdfGeneratorFunctionLink, payload);
      const url = response.data.url;

      if (!url) {
        return null;
      }
      const pdfBlob = await this.APIService.get<Blob>(url, {
        responseType: 'blob',
      });

      return pdfBlob.data;
    } catch (e: GlobalAny) {
      Sentry.captureError(e);

      return null;
    }
  };
}

export const PDFGeneratorController = new OpportunityControllerClass(ExternalAxios);
export const OpportunityController = new OpportunityControllerClass(Axios);
